import { FC } from "react";
import Comment from "./Comment";

interface Props {
  comments: {
    body: string;
    author: string;
    timestamp: number;
    id: string;
  }[];
  userId: string;
}

const CommentsList: FC<Props> = ({ comments, userId }) => {
  return (
    <>
      {comments.map((comment: any, i) => {
        if (comment.users && comment.users.length >= 3) {
          return null;
        } else {
          return <Comment userId={userId} key={i} comment={comment} />;
        }
      })}
    </>
  );
};

export default CommentsList;
